import { useEffect } from 'react'

// All pages have "height:100%" on the root (in App.scss), which is needed for
// designer pages to fill the viewport. Content pages (homepage, etc.) don't need
// this constraint - they should scroll naturally based on content length.
//
// Why useEffect + style tag instead of styled-components createGlobalStyle?
// When hydration errors occur, styled-components may fail to clean up its injected
// <style> tags. This caused a bug where the "height: auto" style persisted
// after navigating away from homepage, breaking the tile designer's layout (causing the tiles to be super small).
// Using useEffect guarantees cleanup runs on unmount, even during error recovery.
function RootHeightAuto() {
  useEffect(() => {
    const style = document.createElement('style')
    style.setAttribute('data-root-height-auto', 'true')
    style.textContent = `
      html, body, #root {
        min-height: 100%;
        height: auto !important;
      }
    `
    document.head.appendChild(style)

    return () => {
      style.remove()
    }
  }, [])

  return null
}

export default RootHeightAuto
